import axios from 'axios';
import SecurityModule from '@/store/modules/SecurityModule';

const instance = axios.create({
  baseURL: (window.location.hostname.includes('.vpc') ? process.env.VUE_APP_API_BASE_URL.replace('.fr', '.vpc') : process.env.VUE_APP_API_BASE_URL) || 'https://localhost:8000',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  // withCredentials: true // send cookies when cross-domain requests
});

const requestInterceptorId = instance.interceptors.request.use(
  (configuration) => {
    return configuration;
  },
);

const responseInterceptorId = instance.interceptors.response.use(
  (response) => {
    // console.log("Response interceptors", response);
    return response;
  },
  (error) => {
    // console.log("Axios errors", error.response.data);

    const data = error.response.data;
    if (
      data.code &&
      data.code === 401 &&
      data.message &&
      data.message === 'Expired JWT Token'
    ) {
      delete instance.defaults.headers.common.Authorization;

      SecurityModule.setUser(null);
      SecurityModule.setToken(null);
      // window.EventManager.fire('token_expired');
    }

    return Promise.reject(error);
  },
);

// // Add a response interceptor
// axios.interceptors.response.use(function (response) {
//     // Do something with response data
//     return response;
// }, function (error) {
//     // Do something with response error
//     console.log(error.response);
//     return Promise.reject(error);
// });

instance.interceptors.request.eject(requestInterceptorId);
// instance.interceptors.response.eject(responseInterceptorId);

export default instance;
